import { Component, OnInit } from '@angular/core';
import { Intercom } from 'ng-intercom';
import { OrderService } from '../../../main/order-management/order.service';
import { CommonService } from '../../../shared/common.service';
import { StreamService } from '../../../shared/stream.service';
import Swal from "sweetalert2";


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['../full.component.scss']
})
export class AppHeaderComponent implements OnInit{
  userData;
  ntervalId:any;
  interval:any;
  NewOrderCount:boolean =false;
  constructor(
    private commonService: CommonService,
    private orderService:OrderService,
    public fileService:StreamService,
    public intercom: Intercom) { }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("userData")) || "noemail";
    this.interval = setInterval( () => {
      this.NewOrder();
      }, 30000);
  }

  audio: HTMLAudioElement;
  play() {
    if (!this.audio) {
      this.audio = new Audio('../../../../assets/newOrder.mp3');
    }
    if (!this.audio.paused) {
      this.audio.pause();
    }
    this.audio.play();
  }
  
  pause() {
    if (this.audio) {
      this.audio.pause();
    }
    }

  logoutUser() { 
    // window.Intercom('update', {
    //   hide_default_launcher: false,
    // });
    this.intercom.shutdown()
      this.commonService.logOut();
  }
  NewOrder() {
    this.orderService.getNewOrder("").subscribe(
      (res) => {

        if (res["message"] == "Success") {

          this.NewOrderCount = res.data.response.isUnseenOrders;
          this.fileService.streamFilterMessage(res.data.response)
          
          if(this.NewOrderCount == true){
            this.play();
            // Swal.fire({
            //   title: 'New order Received',
            //   showClass: {
            //     popup: 'animate__animated animate__fadeInDown'
            //   },
            //   hideClass: {
            //     popup: 'animate__animated animate__fadeOutUp'
            //   }
            // });
            Swal.fire({
              title: 'New order Received',
              showClass: {
                popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              }
            }).then((result) => {
              if (result.isConfirmed) {
                // Call your function here
                this.pause();
              }
            });
           
          }
          console.log('new order',this.NewOrderCount)
        } else {
         
        }
     
      },
      (err) => {
        
      }
    );
  }




}

